module.exports = __webpack_public_path__ + "media/images/redesign-images/graduate-program/tcby-03-e7a52585f4e67a469bc4d254775e143e.webp";